import { Component, ElementRef, forwardRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputDirective } from 'gung-common';
import { filter, Subscription } from 'rxjs';
import { UsersService } from '../../../services/users/users.service';

@Component({
  selector: 'lib-assortment-input',
  templateUrl: './assortment-input.component.html',
  styles: [
    '.dropdown-list { max-height: 400px; overflow: auto; width: 100%; padding-bottom: 0; }',
    '.form-control > .dropdown { padding-left: 0.75rem; padding-right: 0.75rem; }',
    '.dropdown::after { display: none; }',
    '.item:hover { background-color: #f2f2f2; }',
    '.add-new { position: sticky; bottom: 0; background-color: var(--bs-dropdown-bg, #fff); }'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssortmentInputComponent),
      multi: true
    }
  ],
  standalone: false
})
export class AssortmentInputComponent extends BaseInputDirective<string> implements OnInit, OnDestroy {
  @ViewChild('newAssortmentInput') newAssortmentInput: ElementRef<HTMLInputElement>;

  searchString = '';
  filteredList: string[] = [];
  dropdownIsOpen = false;
  isAdding = false;
  newAssortment = '';

  protected assortments: string[] = [];
  protected subscription: Subscription;

  constructor(protected usersService: UsersService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscription = this.usersService
      .getAllUsersSubject()
      .pipe(filter(users => !!users))
      .subscribe(users => {
        this.assortments = users.map(u => u.assortment);
        this.setSearch(this.searchString);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  setSearch(search: string) {
    this.searchString = (search || '').trim();
    const term = this.searchString.toLowerCase();
    this.filteredList = this.getOptions().filter(a => a.toLowerCase().includes(term));
  }

  openChanged(isOpen: boolean) {
    this.dropdownIsOpen = isOpen;
    this.isAdding = false;
    this.setSearch(this.searchString);
  }

  startAdding() {
    this.isAdding = true;
    this.newAssortment = this.filteredList.length === 0 ? this.searchString : '';
    setTimeout(() => this.newAssortmentInput?.nativeElement.focus());
  }

  addNew(): boolean {
    const name = (this.newAssortment || '').trim();
    if (!name) {
      return false;
    }
    const existing = this.getOptions().find(a => a.toLowerCase() === name.toLowerCase());
    this.selected(existing || name);
    return true;
  }

  selected(item: string) {
    this.value = item;
    this.onTouched();
  }

  protected getOptions(): string[] {
    return [...new Set([...this.assortments, this.value].filter(a => !!a))].sort();
  }
}
